/**
 * Copyright(c) 2019 Knut Petter Meen, all rights reserved.
 */
package net.scalytica.blaargh.components

import japgolly.scalajs.react._
import japgolly.scalajs.react.extra.router.RouterCtl
import japgolly.scalajs.react.vdom.html_<^._
import net.scalytica.blaargh.CssSettings._
import net.scalytica.blaargh.models.Article
import net.scalytica.blaargh.pages.Views.ArticleRef
import net.scalytica.blaargh.styles.BlaarghBootstrapCSS
import scalacss.ScalaCssReact._

import scala.concurrent.Future
import scala.scalajs.concurrent.JSExecutionContext.Implicits.queue

object ArticleView {

  object Styles extends StyleSheet.Inline {

    import dsl._

    val post = style("blaargh-post")(
      paddingTop(100 px),
      paddingBottom(5 rem)
    )
  }

  case class Props(
      article: Future[Option[Article]],
      ref: ArticleRef,
      ctl: RouterCtl[ArticleRef]
  )

  case class State(
      article: Option[Article] = None,
      content: Option[String] = None
  )

  class Backend($ : BackendScope[Props, State]) {

    def init: Callback =
      $.props.map[Unit] { p =>
        for {
          metadata <- p.article
          content  <- Article.get(p.ref)
        } yield {
          $.setState(State(metadata, content)).runNow()
        }
      }

    def render(props: Props, state: State) =
      <.div(^.key := "art-view-1",
        ^.className := "content",
        <.div(^.key := "art-view-1-1",
          BlaarghBootstrapCSS.container,
          state.content.map { c =>
            <.div(^.key := "art-view-1-1-a",
              Styles.post,
              state.article.map(a => <.h1(a.title)).getOrElse(EmptyVdom),
              <.span(^.dangerouslySetInnerHtml := c)
            )
          }.getOrElse(
            <.div(^.key := "art-view-1-1-b", Styles.post)
          )
        )
      )
  }

  val component = ScalaComponent
    .builder[Props]("ArticleView")
    .initialStateFromProps(_ => State())
    .renderBackend[Backend]
    .componentDidMount(_.backend.init)
    .build

  def apply(
      article: Future[Option[Article]],
      ref: ArticleRef,
      ctl: RouterCtl[ArticleRef]
  ) = component(Props(article, ref, ctl))

}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/components/ArticleView.scala